import React, {Component} from 'react';
class DownloadingIntent extends Component {
    render() {
        return (
            <div id="toast" style={{zIndex:9000}} className={this.props.isDownloading?"show":"none"}>
                <div id="img"><i aria-hidden='true' className='circle notched loading icon'/></div>
                <div id="desc">Please wait file is downloading...</div>
            </div>
        );
    }
}

export default DownloadingIntent;


// WEBPACK FOOTER //
// ./src/views/universal/toast.js